import React, { useEffect, useState } from 'react';

type TextContentProps = {
    fileBlob: Blob | null;
};

export const TextContent: React.FC<TextContentProps> = ({ fileBlob }) => {
    const [text, setText] = useState<string>('');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!fileBlob) {
            setText('');
            setError(null);
            return null;
        }

        const reader = new FileReader();
        const onLoad = () => {
            setText(reader.result as string);
            setError(null);
        };
        reader.onload = onLoad;
        reader.onerror = () => {
            setError('Failed to read file');
            setText('');
        };
        reader.readAsText(fileBlob);

        return () => {
            reader.abort();
            reader.removeEventListener('load', onLoad);
        };
    }, [fileBlob]);

    if (error) {
        return <div style={{ color: 'red' }}>{error}</div>;
    }

    if (!fileBlob) {
        return null;
    }

    return (
        <pre
            style={{
                whiteSpace: 'pre-wrap',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
                width: '100%',
                height: '100%',
                maxWidth: '100%',
                maxHeight: '100%',
                overflow: 'auto',
                padding: '16px',
                backgroundColor: '#f4f4f4',
                borderRadius: '4px',
                fontFamily: 'monospace',
                fontSize: '14px',
                boxSizing: 'border-box',
            }}
        >
            {text}
        </pre>
    );
};
